import React from "react";
import { createPortal } from "react-dom";
import RedButton from "./RedButton";
import GreyOutlineButton from "./GreyOutlineButton";
import "./common.scss";
import GreenButton from "./GreenButton";

const CancelPopup = ({
  handleNo,
  handleYes,
  heading,
  content,
  image,
  icon,
  confirmation,
  popupClassName,
  confirmDisabled = false,
  cancelDisabled = false,
  confirmLabel = "Confirm",
  cancelLabel = "Cancel",
}) => {
  return createPortal(
    <div className="popup-container" style={{ zIndex: 20010 }}>
      <div className={`popup flex flex-col justify-evenly items-center bg-white rounded-[10px] drop-shadow-[0_3px_3px_rgba(0,0,0,0.25)] popup ${popupClassName || 'w-[335px] sm:w-[470px] h-[275px] sm:h-[255px]'}`}>
        {icon ? (
          <div className="w-[45px] h-[45px] sm:w-[50px] sm:h-[50px] mb-2 flex items-center justify-center">
            {React.cloneElement(icon, { className: "w-full h-full block" })}
          </div>
        ) : image ? (
          <img src={image} className="w-[35px] h-[35px] sm:w-[40px] sm:h-[40px] mb-2 object-contain" />
        ) : null}
        <div className="flex flex-col justify-center items-center sm:gap-2">
          <p className="text-[16px] sm:text-[18px] font-[500] font-poppins text-[#303030] mb-2 text-center">
            {heading}
          </p>
          <p className="text-[11px] sm:text-[13px] font-[400] font-poppins text-[#8C8C8C] text-center max-w-[85%]">
            {content}
          </p>
        </div>
        <div className="w-full flex flex-col sm:flex-row justify-center items-center gap-2 sm:gap-5">
          <button
          onClick={handleNo}
            disabled={cancelDisabled}
            className="h-[35px] sm:h-[40px] w-[120px] font-[500] border border-[#00ADEF] text-[#00ADEF] rounded-[6px] hover:bg-gray-50"
          >
            {cancelLabel}
          </button>
          <button
            onClick={handleYes}
            disabled={confirmDisabled}
            className="h-[35px] sm:h-[40px] w-[120px] font-[500] bg-[#00ADEF] text-white rounded-[6px] hover:bg-[#0098d4]"
          >
            {confirmLabel}
          </button>
        </div>
      </div>
    </div>,
    document.body
  );
};

export default CancelPopup;
